<template>
  <div class="container-fluid pt-2">
    <div class="row" :class="{'section-loading': isLoading_1 || loading_from_family}">
      <div class="col-2 text-center">
        <level :lv="CustInfo.lv" />
        <br/>
        <avatar :gender="Number(CustInfo.gender)" />
        <h3 class="mt-0">
          <!--<b>{{ CustInfo.age? CustInfo.age : '— —' }}歲</b>-->
          <small v-if="CustInfo.age === 0 ">
            <b>0歲</b>
          </small>
          <small v-else-if="CustInfo.age">
            <b>{{CustInfo.age}}歲</b>
          </small>
          <small v-else>
            <b>— —</b>
          </small>
        </h3>
      </div>
      <div class="col-10">
        <div class="row">
          <div class="col-3">
            <div class="item row">
              <div class="col-3 label">姓名</div>
              <div class="col-9 text d-flex">
                <div class="name-block" v-text="getTruncateText(`${CustInfo.name}`, 12, true)"></div><span>{{isLostLife(CustInfo.is_lia)}}</span>
                <a class="link text-underline all-name"
                  @click="registerHanlink"
                  v-show="CustInfo.name && CustInfo.name.length > 6"
                  tabindex="0"
                  id="user-name"
                  data-toggle="popover"
                  role="button"
                  :data-content="CustInfo.name">
                  看全名
                </a>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="item row" v-show="CustInfo.wg_name && CustInfo.wg_name!==''">
              <div class="col-2 label pl-0">原住民名</div>
              <div class="col-10 text d-flex">
                <div style="line-height:20px" class="name-block">{{CustInfo.wg_name}}{{isLostLife(CustInfo.is_lia)}}</div>
                <a class="link text-underline all-name"
                  v-show="CustInfo.wg_name && CustInfo.wg_name.length > 40"
                  tabindex="1"
                  id="aboriginal-name"
                  data-toggle="popover"
                  role="button"
                  :data-content="CustInfo.wg_name">
                  看全名
                </a>
              </div>
            </div>
          </div>
          <div class="text-right action">
            <button v-if="custDieStatus || isDelete || CustInfo.ID === ''" 
            type="button"
            class="btn btn-default btn-sm m-0"
            @click="panelOpen('custConfirmDeleteOpen')">
              刪除客戶
            </button>
            &nbsp;
            <button type="button" @click="panelOpen('contactInfoOpen')" class="btn btn-default btn-sm m-0">
              <i class="icon-edit">編輯資料</i>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <div class="item row">
              <div class="col-3 label">性別</div>
              <div class="col-9 text">
                <span v-if="CustInfo.gender == 2">女</span>
                <span v-else-if="CustInfo.gender == 1">男</span>
                <span v-else>— —</span>
              </div>
            </div>
            <div class="item row">
              <div class="col-3 label pl-0">ID</div>
              <div class="col-9 text">{{CustInfo.ID | emptyField}}</div>
            </div>
            <div class="item row">
              <div class="col-3 label">生日</div>
              <div class="col-9 text">{{CustInfo.birthday | dateFormat}}</div>
            </div>
          </div>
          <div class="col-3">
            <div class="item row">
              <div class="col-4 label">手機</div>
              <div class="col-8 text">{{CustInfo.mobile | emptyField}}</div>
            </div>
            <div class="item row">
              <div class="col-4 label pl-0">住家電話</div>
              <div class="col-8 text">{{CustInfo.phone | phoneFormat | emptyField}}</div>
            </div>
            <div class="item row">
              <div class="col-4 label pl-0">公司電話</div>
              <div class="col-8 text">{{CustInfo.office_phone | phoneFormat | emptyField}}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="item row">
              <div class="col-3 label pl-0">LINE ID</div>
              <div class="col-9 text">{{CustInfo.lineid | emptyField}}</div>
            </div>
            <div class="item row">
              <div class="col-3 label">現居地址</div>
              <div class="col-9 text">
                <span v-if="CustInfo.address && !CustInfo.address[1] && !CustInfo.address[2] && !CustInfo.address[3]">— —</span>
                <a class="link text-underline"
                target="_blank"
                :href="`https://www.google.com/maps/place/${address_filttered}`"
                v-else>
                  {{CustInfo.address | addressFormat | emptyField}}
                </a>
              </div>
            </div>
            <div class="item row">
              <div class="col-3 label">公司地址</div>
              <div class="col-9 text">
                <span v-if="CustInfo.office_address && !CustInfo.office_address[1] && !CustInfo.office_address[2] && !CustInfo.office_address[3]">— —</span>
                <a class="link text-underline"
                target="_blank"
                :href="`https://www.google.com/maps/place/${office_address_filttered}`"
                v-else>
                  {{CustInfo.office_address | addressFormat | emptyField}}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <contact-info-modal
    :open="contactInfoOpen"
    :inputs="CustInfo"
    :isRelation="isRelation"
    @submit="contactSubmit"
    @close="panelClose('contactInfoOpen')"/>

    <confirm-delete
    :open="confirmDeleteOpen"
    :input-data="CustInfo"
    @close="panelClose('confirmDeleteOpen')"
    @confirm="deleteCustomer"/>

    <cust-confirm-delete
    :open="custConfirmDeleteOpen"
    :input-data="CustInfo"
    @close="panelClose('custConfirmDeleteOpen')"
    @confirm="deleteCustomer"/>

    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" content="資料刪除中，請稍候..." />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { commonMixin } from '../../../mixins/common';
import Avatar from '../../components/Avatar';
import Level from '../../components/Level';
import ContactInfoModal from '../ContactInfoModal';
import ConfirmDelete from '../ConfirmDelete';
import CustConfirmDelete from '@/desktop/components/CustConfirmDelete'
import { deleteCust,getCustInfo,editCustInfo, AddLatAndLnt, queryIAACust, getFamilyMemberByCsidNo, insertDataCollectionLog } from '../../../service';
import { setTimeout } from 'timers';
import mxMask from "@/desktop/components/mxMask";

export default {
  name: 'CustomerInfo',
  mixins: [commonMixin],
  props: {
    loading_from_family:{
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    custDieStatus: {
      type: Boolean,
      default: false
    },
    runEnv: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isLoading_1: this.loading,
      contactInfoOpen: false,
      confirmDeleteOpen: false,
      custConfirmDeleteOpen: false,
      address_T: "",
      office_address_T: "",
      // office_address_filttered:[],
      // address_filttered:[],
      // address_filttered_0: "",
      // office_address_filttered_0: "" 
      mxMaskOpen: false,
      isRelation: false,
      isDelete: false //判斷客戶關係決定是否可刪除客戶
    }
  },
  computed: {
    ...mapGetters(['BaseUrl', 'CustInfo', 'UserInfo']),
      office_address_filttered(){
        let office_address_filttered_0="";
        if(this.CustInfo.office_address[0].length == 5){
          office_address_filttered_0 = this.CustInfo.office_address[0].substring(0, 3);
        }else{
          office_address_filttered_0 = this.CustInfo.office_address[0]
        }
        let val = this.CustInfo.office_address[3];
        let pattern = /^[0-9]+$/;
        if(val && val.trim() && val !== '— —'){
          val = val.trim();
          let len = val.length;
          let firstWords = val.substring(0, 5);

          if (pattern.test(firstWords)) {
            let words = val.substring(5, len);
            val = val.substring(0, 3);
            val = val + words;
            return  [office_address_filttered_0, this.CustInfo.office_address[1], this.CustInfo.office_address[2], val];
          }else{
            return [office_address_filttered_0, this.CustInfo.office_address[1], this.CustInfo.office_address[2], this.CustInfo.office_address[3]];
          } 
        }else{
          return  [office_address_filttered_0, this.CustInfo.office_address[1], this.CustInfo.office_address[2], this.CustInfo.office_address[3]];
        }
      },
      address_filttered(){
        let address_filttered_0="";
        if(this.CustInfo.address[0].length == 5){
          address_filttered_0 = this.CustInfo.address[0].substring(0, 3);
        }else{
          address_filttered_0 = this.CustInfo.address[0]
        }
        let val = this.CustInfo.address[3];
        let pattern = /^[0-9]+$/;
        if(val && val.trim() && val !== '— —'){
          val = val.trim();
          let len = val.length;
          let firstWords = val.substring(0, 5);

          if (pattern.test(firstWords)) {
            let words = val.substring(5, len);
            val = val.substring(0, 3);
            val = val + words;
            return  [address_filttered_0, this.CustInfo.address[1], this.CustInfo.address[2], val];
          }else{
            return [address_filttered_0, this.CustInfo.address[1], this.CustInfo.address[2], this.CustInfo.address[3]];
          } 
        }else{
          return  [address_filttered_0, this.CustInfo.address[1], this.CustInfo.address[2], this.CustInfo.address[3]];
        }

      }
  },
  watch: {
    'loading' : function() {
      this.isLoading_1 = this.loading
      
    },
    CustInfo: function(){
      this.registerHanlink()
    },

  },
  components: {
    Avatar, Level, ContactInfoModal, ConfirmDelete, CustConfirmDelete, mxMask
  },
  methods: {
    ...mapActions([
      'setPageLock' , 'updateCustInfo'
    ]),
    setCustInfo(user) {
      let custInfo = {
        lv: Number(user.vip_lvl || '0'),
        familyLeader: false,
        name: user.name || '',
        gender: user.sex || 0,
        birthday: user.birthday || '',
        ID: user.id || '',
        age: (user.age==0 ||user.age) ? user.age :'',
        serNo: user.ser_no || '',
        lineid: user.lineid || '',
        mobile: user.mobile? user.mobile.trim() : '',
        phone: [user.home_tel_area? user.home_tel_area.trim() : '', user.home_tel? user.home_tel.trim() : ''],
        office_phone: [user.corp_tel_area? user.corp_tel_area.trim() : '', user.corp_tel? user.corp_tel.trim() : '', user.corp_tel_ext? user.corp_tel_ext.trim() : ''],
        fax: [user.fax_area? user.fax_area.trim() : "", user.fax? user.fax.trim() : ""],
        // fax: '',
        address: [user.home_addr_zip? user.home_addr_zip.trim() : '', user.home_addr1? user.home_addr1.trim() : '', user.home_addr2? user.home_addr2.trim() : '', user.home_addr3? user.home_addr3.trim() : ''],
        office_address: [user.corp_addr_zip? user.corp_addr_zip.trim() :'', user.corp_addr1? user.corp_addr1.trim() :'', user.corp_addr2? user.corp_addr2.trim() :'', user.corp_addr3? user.corp_addr3.trim() :''],
        wg_name: user.wg_name || '',
        relation:{source1:user.relation.source1,source2:user.relation.source2,source3:user.relation.source3,source4:user.relation.source4,source5:user.relation.source5,source6:user.relation.source6,source1_pltn:user.relation.source1_pltn},
        is_lia: user.is_lia || '',
      }
      
      this.updateCustInfo(custInfo)
 
    },
    isLostLife(is_lia){
      return is_lia == 'Y' ? ' (歿)' : ''
    },
    contactSubmit(custInfo) {
      this.panelClose('contactInfoOpen')
      this.isLoading_1 = true
      console.log(custInfo);

      //紀錄log
      let cust_Id = custInfo.ID ? custInfo.ID : custInfo.serNo;
      insertDataCollectionLog(this.$store.state.userInfo.id, cust_Id, "EDIT_CONTACTINFO").then(result => {
        if(!result.header || !result.header.status === '200') {
            if(result.header.message) {
              this.$toast.info({title: result.header.message})
            } else {
              this.$toast.info({title: `${resMessage}`})
            }     
        }
      })

      let idCheck = custInfo.ID && custInfo.serNo; //ID和流水號同時有值:無ID轉有ID
      let custId = custInfo.serNo ? custInfo.serNo : custInfo.ID;
      //取得familyrl
      getFamilyMemberByCsidNo(this.$store.state.userInfo.id, custId).then(result => {
          custInfo.familyrl = "";
          if(
            result.header &&
            result.header.status === "200" &&
            result.data
          ){
            result.data.forEach(item => {
              if(item.csidno == custId){
                custInfo.familyrl = item.familyrl;
              }
            });
          }
        let custNo = this.$store.state.custInfo.ID || ''
        editCustInfo(this.$store.state.userInfo.id, custNo, custInfo, null).then(result => {
          const resMessage = result.header.message
          if(result.header && result.header.status === '200') {
            // this.updateCustInfo(custInfo)
            getCustInfo(this.$store.state.userInfo.id, this.$store.state.userInfo.id, (custInfo.ID || custInfo.serNo)).then(result => {
              this.setCustInfo(result.body.customer)
              if (idCheck) {
                //無ID轉有ID成功儲存後，變更localStorage的值
                localStorage.CustID = result.body.customer.id;
                localStorage.SerNo = "";
              }
              this.isLoading_1 = false
              this.$toast.info({title: `${resMessage}`})
              this.$emit('initDetailTwo')
            })
            this.address_T = custInfo.address[1]+this.getValidValue(custInfo.address[2])+custInfo.address[3];
            this.office_address_T =  custInfo.office_address[1]+this.getValidValue(custInfo.office_address[2])+custInfo.office_address[3];
            this.AddLatAndLntToDB(custInfo.ID, custInfo.serNo);

            if (this.isBox) {
              let custId = custInfo.ID !== ''?custInfo.ID:custInfo.serNo
              //若内嵌於Box, 將客戶資訊回傳給Box
              this.boxCustInfoUpdate(custId, custInfo.name);
            } 
          } else {
            this.isLoading_1 = false
            if(result.header.message) {
              this.$toast.info({title: result.header.message})
            } else {
              this.$toast.info({title: `${resMessage}`})
            }
          }
        });
      });
    },AddLatAndLntToDB(ID,serNo){
        let key="";
        if(ID){
          key=ID;
        }else{
          key=serNo;
        }
        //新增現居地址經緯度(type=1)
        if(this.address_T){
          AddLatAndLnt(this.$store.state.userInfo.id, key, this.address_T,"1").then(result => {
            if(result.header && result.header.status && result.header.status === '200'){
              //this.$toast.info({title: `${result.header.message}`})
            }else{
              this.$toast.info({title: `更新客戶成功但更新現居地址經緯度失敗`})
            }
          })
        }
        //新增公司地址經緯度(type=2)
        if(this.office_address_T){
          AddLatAndLnt(this.$store.state.userInfo.id, key, this.office_address_T,"2").then(result => {
            if(result.header && result.header.status && result.header.status === '200'){
              //this.$toast.info({title: `${result.header.message}`})
            }else{
              this.$toast.info({title: `更新客戶成功但更新公司地址經緯度失敗`})
            }
          })
        }
    },
    getValidValue(value){
      if('string' === typeof value)
        return value

      if('object' === typeof value && value.name)
        return value.name
      
      return ""
    },
    deleteCustomer () {
      this.panelOpen("mxMaskOpen");//開啟遮罩
      //custNo 後續要加判斷是否為無ID客戶

      let custNo = this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo

      deleteCust(this.$store.state.userInfo.id, custNo, "", this.$store.state.custInfo.name,"").then(result =>{
        this.panelClose("mxMaskOpen");//關閉遮罩
        if(result && result.header.status == '200'){
          this.panelClose('confirmDeleteOpen')

          // 更新 custInfo 及 localstorage CustID
          let emptyCust = {
            lv: 0,
            familyLeader: false,
            name: '',
            gender: 0,
            birthday: '',
            mobile: '',
            phone: ['', ''],
            fax: ['', ''],
            ID: '',
            office_phone: ['', '', ''],
            address: ['', '', '', ''],
            office_address: ['', '', '', ''],
            lineid: '',
            wg_name: '',
            serNo: '',
          }
          localStorage.CustID = ''
          localStorage.SerNo = ''
          this.$toast.info({title: `已刪除「${this.CustInfo.name}」`})
          this.updateCustInfo(emptyCust)
          this.$router.push({path:`/`})

        }
        else{
          this.$toast.info({title: `錯誤「${result.header.message}」`})
          this.panelClose('confirmDeleteOpen')
        }
      })   
      
    },
    queryCustInfo(){    
      let agID = this.UserInfo.id || this.$store.state.userInfo.id || "";
      let custID = this.CustInfo.ID || this.$store.state.custInfo.ID || this.CustInfo.serNo || this.$store.state.custInfo.serNo || "";
      getCustInfo(agID, agID, custID).then(result => {
        let relate1_pltn = result.body.customer.relation ? result.body.customer.relation.source1_pltn : '0';
        if( relate1_pltn=="1"||  relate1_pltn=="2"||  relate1_pltn=="3"){
          this.isRelation = true;
        }else{
          this.isRelation = false;
        }
        this.$emit('passIsRelation', this.isRelation);
      })
    },
    //初始化
    init() {
      this.queryCustInfo();
      //客戶關係只有純團險or旅平險的客戶也可刪除
      this.isDelete =
        this.CustInfo.relation &&
        ((this.CustInfo.relation.source1 == "0" &&
          this.CustInfo.relation.source2 == "0" &&
          this.CustInfo.relation.source3 == "0" &&
          this.CustInfo.relation.source4 == "0" &&
          this.CustInfo.relation.source5 == "0") ||
          (this.CustInfo.relation.source5 == "1" &&
            this.CustInfo.relation.source1 == "0" &&
            this.CustInfo.relation.source2 == "0" &&
            this.CustInfo.relation.source3 == "0" &&
            this.CustInfo.relation.source4 == "0" &&
            this.CustInfo.relation.source6 == "0") ||
          (this.CustInfo.relation.source3 == "1" &&
            this.CustInfo.relation.source1 == "0" &&
            this.CustInfo.relation.source2 == "0" &&
            this.CustInfo.relation.source4 == "0" &&
            this.CustInfo.relation.source5 == "0" &&
            this.CustInfo.relation.source6 == "0"));
    }
  },
  mounted () {
    window.$('#user-name').popover({
      trigger: 'focus',
      placement: 'bottom'
    })
    window.$('#aboriginal-name').popover({
      trigger: 'focus',
      placement: 'bottom'
    })
    if (this.runEnv) {
      this.init();
    }
    //  for 難字更新
    setTimeout(() => {
      this.registerHanlink()
    }, 200);
  }
}
</script>

